<template>
  <div id="orderConfirmation">
    <div class="sector fs30 bg-darker">
      Прежде чем заказать, проверьте, все ли данные верны
    </div>

    <div class="bg-darker sector df fr wa t-medium">
      <div class="sector">
        <p v-if="isGamepasses">Название gamepass</p>
        <p>Получатель</p>
        <p>Вы получите</p>
        <p>Вы заплатите</p>
        <p>Тип</p>
      </div>
      <div class="sector">
		<p v-if="data.name">{{ data.name }}</p>
		<p v-if="!data.sellerName && isGamepasses">&lt;{{ data.gamepassesIds.length }} штук(и)&gt;</p>
		<p>{{ data.sellerName ?? "<неск>" }}</p>
        <p><span class="t-red">{{ data.amount * (data.dupe ? data.dupe : 1) }} R$</span></p>
        <p><span class="t-green">{{ price }} ₽</span></p>
        <p v-if="data.preorder">Предзаказ</p>
        <p v-else>Обычный заказ</p>
	  </div>
    </div>
    <button class="fs24 green" @click="agree">Всё верно</button>
    <button class="fs20 red" @click="$root.restart">Назад</button>
  </div>
</template>

<script>
export default {
  props: ["data"],

  computed: {
	price() {
	  const rate = this.isGamepasses ? this.$root.common.rate : this.$root.common.groupRate;
	  let discount = 0;
	  if (this.data.bonus)
		discount = this.data.bonus / rate;
	  return Math.round(-discount + this.data.amount * (this.data.dupe ? this.data.dupe : 1) / rate)
	},

	isGamepasses() {
	  return this.data.hasOwnProperty("gamepassesIds")
	}
  },

  methods: {
	agree() {
	  this.$root.order(this.data)
	}
  }
}
</script>

<style scoped lang="scss">
#orderConfirmation {
  width: 800px;
}
</style>
